import React, { Component } from "react";
import { API } from "aws-amplify";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form } from "react-bootstrap";
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";
import "./RegisterUser.css";

const schema = Yup.object({
  Email: Yup.string().required()
  .matches(/^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'Invalid email address')
});

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBusy: false,
      alertMessage: "",
    };
  }

  onDismiss = () => this.setState({ alertMessage: "" });;

  handleSubmit = async event => {
    this.setState({ isBusy: true, alertMessage: "" });
    try {
      let post = { body: { username: event.Email }}
      await API.post("license", "/register-user", post);
      this.setState({ isBusy: false });
      this.props.history.goBack();
    } catch (e) {
      if (e.response.status === 400) {
        this.setState({ alertMessage: e.response.data});
      } else {
        this.setState({ alertMessage: e.message});
      }
      this.setState({ isBusy: false });
    }
  };

  renderForm() {
    return (
      <div>
      <Formik
      validateOnChange={false}
      validationSchema={schema}
      onSubmit={this.handleSubmit}
      initialValues={{
        Email: '',
        password: '',
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
      <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <div className="content">
          <h2>DataStar User Registration</h2>
          <div>Registration allows users to access the DataStar License key that has been allocated to their organisation.</div>
          <div>The organisation is identied from your email domain. If your organisation is not registered please contact <a href = "mailto: sales@absolute.technology">sales@absolute.technology</a></div>
        </div>
        <Form noValidate onSubmit={handleSubmit}>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control className="form-control-sm"
            name="Email"
            value={values.Email}
            placeholder="Enter email"
            type="email"
            onChange={handleChange}
            isInvalid={!!errors.Email}
          />
          <Form.Control.Feedback type="invalid">
              {errors.Email}
          </Form.Control.Feedback>
        </Form.Group>
        <LoaderButton
          block
          bsSize="small"
          type="submit"
          isLoading={this.state.isBusy}
          text="Register"
          loadingText="Registering…"
        />
      </Form>
      </div>
       )}
       </Formik></div>
     );
  }

  render() {
    return (
      <div className="main">
        {this.renderForm()}
      </div>
    );
  }
}
